import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setCurrentStep } from "../../state/reducers/architectureConversion";
import { Col, Container, Row } from "react-bootstrap";
import InputField from "../../common-components/input-field/Input-field.jsx";
import CustomButton from "../../common-components/button/Button.jsx";
import { excludedDirs } from "./arch-options";

function ArchChooseFile({setSourceFiles, sourceFiles, setGitRepoUrl}) {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("upload");
  const [gitUrl, setGitUrl] = useState("");

  const handleNext = () => {
    if (selectedOption === "upload" && sourceFiles.length > 0) {
      dispatch(setCurrentStep(2));
    } else if (selectedOption === "git" && gitUrl) {
      setGitRepoUrl(gitUrl);
      dispatch(setCurrentStep(2));
    } else {
      alert("Please select a folder or enter a valid Git repository URL.");
    }
  };

  const handleFolderUpload = async (event) => {
    const items = Array.from(event.target.files);
        
    const filteredFiles = items.filter(file => {
      const pathParts = file.webkitRelativePath.split("/");
      return !excludedDirs.some(dir => pathParts.includes(dir));
    });

    setSourceFiles(filteredFiles);
  };

  const handleGitUrlChange = (event) => {
    setGitUrl(event.target.value);
  };

  return (
    <div className="page-wrapper arch-page">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Choose Architecture Source</h2>
            <div className="arch-wrapper">
              <Row className="mb-3">
                <Col md={4}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="sourceOption"
                      id="uploadOption"
                      checked={selectedOption === "upload"}
                      onChange={() => setSelectedOption("upload")}
                    />
                    <label className="form-check-label" htmlFor="uploadOption">
                      Upload Folder
                    </label>
                  </div>  
                </Col>
                <Col md={6}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="sourceOption"
                      id="gitOption"
                      checked={selectedOption === "git"}
                      onChange={() => setSelectedOption("git")}
                    />
                    <label className="form-check-label" htmlFor="gitOption">
                      Git Repository URL
                    </label>
                  </div>
                </Col>
              </Row>  
              <Row className="mb-3">
                <Col md={6}>
                  {selectedOption === "upload" && (
                    <InputField 
                      id="files" 
                      type="file" 
                      label="Upload Files" 
                      onChange={handleFolderUpload}
                      layoutStyle="horizontal"
                      labelColSize={4}
                      inputColSize={8}
                      required
                      multiple
                      webkitdirectory="true"
                    />
                  )}
                  {selectedOption === "git" && (
                    <InputField 
                      id="gitUrl" 
                      type="text" 
                      label="Git Repository URL" 
                      onChange={handleGitUrlChange}
                      value={gitUrl}
                      layoutStyle="horizontal"
                      labelColSize={4}
                      inputColSize={8}
                      required
                    />
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  
                </Col>
              </Row>
            </div>            
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="text-end">
            <CustomButton onClick={handleNext} label="Next" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ArchChooseFile;